"use strict";
exports["-4b9d1845"] = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizDaneValidationTitleText","properties":{"FQDNs":{"type":"string","title":"WizDaneValidationFqdnLabel","maxLength":250},"testType":{"type":"string","title":"DaneValidationTestTypeSelection","default":"DnssecAndDaneTest","enum":["DnssecAndDaneTest","DnssecOnlyTest","BaselineTest"],"enumNames":["DaneValidationDnssecAndDaneTest","DaneValidationDnssecOnlyTest","DaneValidationBaselineTest"],"enumHelpers":["DaneValidationDnssecAndDaneTestHelper","DaneValidationDnssecOnlyTestHelper","DaneValidationBaselineTestHelper"]},"proofOfWork":{"type":"string","title":""}},"required":["FQDNs","testType","proofOfWork"],"$id":"-4b9d1845"};
const func2 = require("ajv/dist/runtime/ucs2length").default;

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="-4b9d1845" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.FQDNs === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "FQDNs"},message:"must have required property '"+"FQDNs"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.testType === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "testType"},message:"must have required property '"+"testType"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.proofOfWork === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.FQDNs !== undefined){
let data0 = data.FQDNs;
if(typeof data0 === "string"){
if(func2(data0) > 250){
const err3 = {instancePath:instancePath+"/FQDNs",schemaPath:"#/properties/FQDNs/maxLength",keyword:"maxLength",params:{limit: 250},message:"must NOT have more than 250 characters",schema:250,parentSchema:schema11.properties.FQDNs,data:data0};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
else {
const err4 = {instancePath:instancePath+"/FQDNs",schemaPath:"#/properties/FQDNs/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.FQDNs.type,parentSchema:schema11.properties.FQDNs,data:data0};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
}
if(data.testType !== undefined){
let data1 = data.testType;
if(typeof data1 !== "string"){
const err5 = {instancePath:instancePath+"/testType",schemaPath:"#/properties/testType/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.testType.type,parentSchema:schema11.properties.testType,data:data1};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(!(((data1 === "DnssecAndDaneTest") || (data1 === "DnssecOnlyTest")) || (data1 === "BaselineTest"))){
const err6 = {instancePath:instancePath+"/testType",schemaPath:"#/properties/testType/enum",keyword:"enum",params:{allowedValues: schema11.properties.testType.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.testType.enum,parentSchema:schema11.properties.testType,data:data1};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data2 = data.proofOfWork;
if(typeof data2 !== "string"){
const err7 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data2};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
}
else {
const err8 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
